
import { createGlobalStyle } from 'styled-components'

import ApercuProBold  from './ApercuPro-Bold.woff2'
import ApercuProLight2  from './ApercuPro-Light.woff2'
import ApercuProLight  from './ApercuPro-Light.woff'
import FranklinGothicStdDC2 from "./ITCFranklinGothicStd-Demi.woff2"
import FranklinGothicStdDC  from './ITCFranklinGothicStd-Demi.woff'

export default createGlobalStyle`
  @font-face {
    font-family: 'Apercu Pro';
    src: url(${ApercuProBold}) format('woff2'),
         url(${ApercuProBold}) format('woff2');
    font-weight: bold;
    font-style: normal;
  }

  @font-face {
    font-family: 'Apercu Pro';
    src: url(${ApercuProLight2}) format('woff2'),
         url(${ApercuProLight}) format('woff');
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: 'ITC Franklin Gothic Std';
    src: url(${FranklinGothicStdDC2}) format('woff2'),
         url(${FranklinGothicStdDC}) format('woff');
    font-weight: 400;
    font-style: normal;
  }
`
